import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Companies = lazy(() => import('./pages/Companies'));
const CompanyDetails = lazy(() => import('./pages/CompanyDetails'));
const CreateCompany = lazy(() => import('./pages/CreateCompany'));
const UpdateCompany = lazy(() => import('./pages/UpdateCompany'));

const companyRoutes: RouteObject[] = [
    {
        index: true,
        element: <Companies />,
    },
    {
        path: 'create',
        element: <CreateCompany />,
    },
    {
        path: ':id',
        element: <CompanyDetails />,
    },
    {
        path: ':id/edit',
        element: <UpdateCompany />,
    },
];

export default companyRoutes;
